import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=72236ab2"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72236ab2')) {
      api.createRecord('72236ab2', component.options)
    } else {
      api.reload('72236ab2', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=72236ab2", function () {
      api.rerender('72236ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SidebarA/Link.vue"
export default component.exports